import { render, staticRenderFns } from "./NewEmailNotificationDropdownList.vue?vue&type=template&id=46d63b48&"
import script from "./NewEmailNotificationDropdownList.vue?vue&type=script&lang=js&"
export * from "./NewEmailNotificationDropdownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports